// removed by extract-text-webpack-plugin
module.exports = {"root":"CountrySelector-module-root-2GmMm","container":"CountrySelector-module-container-1wZD2","label":"CountrySelector-module-label-1vt5w","select":"CountrySelector-module-select-2WFuL","is-error":"CountrySelector-module-is-error-3oYRE","isError":"CountrySelector-module-is-error-3oYRE","icon":"CountrySelector-module-icon-3E7hF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CountrySelector/CountrySelector.module.scss
// module id = 958
// module chunks = 0